/*
 * @Description:
 * @Date: 2024-12-16 11:01:42
 */
import OpenNewWin from '@/utils/win';
import { FILE_VIEW_URL } from '@/config';

export const preview = (url: string) => {
  const win = new OpenNewWin();
  win.createWin();
  win.setUrl(`${FILE_VIEW_URL}?url=${url}`);
};
/**
 * @description: 解析文本blob
 * @param {Blob} file
 * @return {Object|String} 解析成功返回对象，失败返回字符串
 */
export const readAsTextCust = async (file: Blob) => {
  const resultStr = await new Promise((resolve, reject) => {
    if (file.type.startsWith('application/json')) {
      const fileReader = new FileReader();
      fileReader.onload = () => {
        const jsonData = JSON.parse(fileReader.result as string);
        resolve(jsonData);
      };
      fileReader.onerror = () => reject('reader error');
      fileReader.readAsText(file);
    } else {
      reject('文件流无法解析json');
    }
  });
  return resultStr;
};
